import authSlice from "./authSlice";
const authActions = authSlice.actions;
export const {
  setUser,
  setToken,
  setRefreshToken,
  setUserMobileNumber,
  setUserEmail,
  setAuthLoading,
} = authActions;
